module.exports = __webpack_public_path__ + "img/v8.8b77e20f.svg";